import { pageHold } from '@paige/capturepoint';

/**
 * Why Paige must not reload this tab on its own right now, or null when nothing would be lost
 * (docs/engineering/web.md, "When Paige is updated"). Two sources, either enough:
 *
 * - the workbench's own holds (`pageHold`, packages/capturepoint/src/paige/page-holds.ts): files
 *   going up, a reading being followed, pages waiting to be read, unsaved setup, review drafts or a
 *   save under way;
 * - any `beforeunload` guard that would ask before leaving: a cancelable `beforeunload` is
 *   dispatched to the page's own listeners, and one that cancels it is a guard saying "ask first".
 *   The browser never sees this event, so nothing is shown and nothing unloads.
 */
export function reloadHold(
  workbench: () => string | null = pageHold,
  win: Window = window,
): string | null {
  return workbench() ?? (leavingGuarded(win) ? 'leave-guard' : null);
}

export function leavingGuarded(win: Window = window): boolean {
  const probe = new Event('beforeunload', { cancelable: true });
  try {
    win.dispatchEvent(probe);
  } catch {
    // A listener that throws cannot say the page is free.
    return true;
  }
  return probe.defaultPrevented;
}
